
import { importSync as i, macroCondition, getGlobalConfig } from '@embroider/macros';
let w = window;
let d = w.define;


i("./-embroider-implicit-modules.js");

d("dummy/app", function(){ return i("dummy/app.js");});
d("dummy/config/editor-profiles", function(){ return i("dummy/config/editor-profiles.js");});
d("dummy/config/environment", function(){ return i("dummy/config/environment.js");});
d("dummy/config/mandatee-table-sample-config", function(){ return i("dummy/config/mandatee-table-sample-config.ts");});
d("dummy/router", function(){ return i("dummy/router.js");});
d("dummy/services/page-title", function(){ return i("dummy/services/page-title.js");});
d("dummy/services/file-queue", function(){ return i("dummy/services/file-queue.js");});
d("dummy/models/template", function(){ return i("dummy/models/template.js");});
d("dummy/services/import-rdfa-snippet", function(){ return i("dummy/services/import-rdfa-snippet.js");});
d("dummy/component-managers/glimmer", function(){ return i("dummy/component-managers/glimmer.js");});
d("dummy/services/toaster", function(){ return i("dummy/services/toaster.js");});
d("dummy/services/-ensure-registered", function(){ return i("dummy/services/-ensure-registered.js");});
d("dummy/services/intl", function(){ return i("dummy/services/intl.js");});
d("dummy/initializers/leaflet-assets", function(){ return i("dummy/initializers/leaflet-assets.js");});
d("dummy/services/ember-leaflet", function(){ return i("dummy/services/ember-leaflet.js");});
d("dummy/utils/calculate-position", function(){ return i("dummy/utils/calculate-position.js");});
d("dummy/services/text-measurer", function(){ return i("dummy/services/text-measurer.js");});
d("dummy/container-debug-adapter", function(){ return i("dummy/container-debug-adapter.js");});
d("dummy/templates/besluit-sample", function(){ return i("dummy/templates/besluit-sample.hbs");});
d("dummy/controllers/besluit-sample", function(){ return i("dummy/controllers/besluit-sample.ts");});
d("dummy/templates/regulatory-statement-sample", function(){ return i("dummy/templates/regulatory-statement-sample.hbs");});
d("dummy/controllers/regulatory-statement-sample", function(){ return i("dummy/controllers/regulatory-statement-sample.ts");});
d("dummy/templates/snippet-edit-sample", function(){ return i("dummy/templates/snippet-edit-sample.hbs");});
d("dummy/controllers/snippet-edit-sample", function(){ return i("dummy/controllers/snippet-edit-sample.ts");});
d("dummy/templates/application", function(){ return i("dummy/templates/application.hbs");});
d("dummy/routes/application", function(){ return i("dummy/routes/application.js");});





if (!runningTests) {
  i("../app").default.create({});
}

